import React from 'react';
import { Subject } from 'rxjs';

import { SlLEContext } from '../../private/global-constants';
import { SlActionsService } from '../../private/services/ActionsService/sl-actions.service';
import { CoursesContainer } from '../../private/containers/CoursesContainer/CoursesContainer';
import { useComponentWillMount } from '../../../shared/public/SlUtils/useComponentWillMount';
import { Container } from '../../../symphony';

export function LECourses(): JSX.Element {
	useComponentWillMount(() => {
		const unsubscriber = new Subject<void>();
		Container.register(SlLEContext, 'unsubscriber', unsubscriber);

		Container.take(SlLEContext, SlActionsService);
	});

	return <CoursesContainer />;
}
